import { render, staticRenderFns } from "./circulo-credito-score-dashboard.vue?vue&type=template&id=ec01e52c&scoped=true&"
import script from "./circulo-credito-score-dashboard.vue?vue&type=script&lang=js&"
export * from "./circulo-credito-score-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec01e52c",
  null
  
)

export default component.exports